module.exports = __webpack_public_path__ + "media/icons/color-select@3x-7f916dbc.svg";